export default "__VITE_ASSET__EokX75yP__"